module.exports = __webpack_public_path__ + "static/media/email.77c83e33.svg";